import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import TabelSummary from '../../comman/tableEstimationSummery';
import { IoArrowBack } from 'react-icons/io5';
import { toast } from 'react-toastify';
import ReasonModal from '../../comman/reasonModel';
import { BiDownload } from "react-icons/bi";
import TableComponent from '../../comman/tableComponent';
import axios from 'axios';
import capitalizeFirstLetter from '../../comman/capitalizeFirstLetter';

const Base_Url = process.env.REACT_APP_BASE_URL;
const documentTableColumns = [
  {
    label: "Sr. No",
    field: "srNo",
    headerClassName: "text-center border-l border-t border-b border-[#d3cccc] px-2 py-2",
    className: "text-center text-sm xl:text-base border-l border-t border-b border-[#d3cccc] px-2 py-2",
    render: (row, index) => index + 1
  },
  {
    label: "File Name",
    field: "documentName",
    headerClassName: "text-left border-t border-b border-[#d3cccc] px-2 py-2",
    className: "text-left text-sm xl:text-base border-t border-b border-[#d3cccc] px-2 py-2",
  },
  {
    label: "Action",
    field: "action",
    headerClassName: "text-center border-r border-t border-b border-[#d3cccc] px-2 py-2",
    className: "text-center text-sm xl:text-base border-r border-t border-b border-[#d3cccc] px-2 py-2",
    render: (row) => (
      <a
        href={row.document} 
        download={row.documentName || "document.pdf"} 
        className="text-blue-600 hover:underline flex items-center justify-center"
      >
        <BiDownload className='flex justify-center text-xl xl:text-2xl'/>
      </a>
    ),
  },
];

export default function ViewEstimation() {
  const {id}=useParams();
  const navigate=useNavigate();
  const [loading,setLoading]=useState(false);
  const [service,setService]=useState(null);
     
    useEffect(() => {
      if (id) fetchBookedServices();
    }, [id]);
  
    const fetchBookedServices = async () => {
    try {
      setLoading(true);
  
      const token = localStorage.getItem("token"); 
  
      const response = await axios.get(`${Base_Url}/api/bookedService/getEstimation/${id}`, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      if (response.data.success) {
        setService(response.data.data);
      } else {
        toast.error(response.data.message || "Failed to fetch data");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error.response?.data?.message || "Something went wrong while fetching"
      );
    } finally {
      setLoading(false);
    }
    };

  const [modalOpen, setModalOpen] = useState(false);
  const [modalType, setModalType] = useState(""); 

  const handleAcceptRequest=()=>{
    setModalType("approved");
    setModalOpen(true); 
  }

  const handleRejectRequest=()=>{
    setModalType("rejected");
    setModalOpen(true);    
  }

  const handleModalSubmit = async(reason) => {
    console.log(reason);
    console.log(modalType);
    try {
        const token = localStorage.getItem("token");
        const res = await axios.put(
          `${Base_Url}/api/bookedService/respondEstimation/${id}`,
          {clientApprovalStatus:modalType, clientApprovalReason:reason},
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        toast.success(res.data.message || "Request accepted successfully..");
        setModalOpen(false);
      } catch (err) 
      {
        console.error(err);
        if (err.response?.status === 400) {
            toast.info(err.response.data?.message);
        } else 
        {
        toast.error(err.response?.data?.message || `Failed to ${modalType} request`);
        }
      }
  }     

  if (loading) {
    return <p className="text-center text-gray-500 py-10">Loading estimation for your booked service...</p>;
  }

  if (!service) {
    return <p className="text-center text-gray-500 py-10">service data not found...</p>;
  }
  return (
    <div className="px-6 xl:px-10 py-6 space-y-5">
        <div className="flex flex-row space-x-2 items-center text-sm md:text-base xl:text-lg font-semibold text-[#A63F40]" 
        onClick={()=>navigate(-1)}>
            <IoArrowBack />
            <p className="font-semibold">Estimation Summary</p>
        </div>
        
        <div className="overflow-x-auto mb-6">
            <TabelSummary
                submittedData={service?.items}
            />
        </div>

        <div className='flex flex-row space-x-5'>
          <div className="text-sm xl:text-base w-2/3">
            <p className='font-semibold text-base xl:text-lg text-[#A63F40] pb-3'>
                Documents - 
            </p>
            {service.documents.length > 0 ? (
                <TableComponent
                    columns={documentTableColumns}
                    data={service.documents}
                    headerBg="bg-[#f6f6f6]"
                />
            ) : (
                <p className="text-gray-500">No documents available</p>
            )}
          </div>
        
        <div className="text-sm xl:text-base rounded-md px-3 w-1/3 ml-auto">
            <p className='font-semibold text-base xl:text-lg text-[#A63F40] pb-3'>Service Cost detail - </p>
            <ul className="space-y-2 border border-[#d3cccc] rounded-lg p-3">
                <li>
                    <b>Overall Service Cost :</b>{" "}
                    {service.totalCost ? `₹${parseFloat(service.totalCost)}` : "₹0"}
                    {/* ₹ {parseFloat(service.totalCost)} */}
                </li>
                <li>
                    <b>Discount :</b>{" "}
                    {parseFloat(service.discountPercent)} %
                </li>
                <li>
                    <b>Final Cost :</b>{" "}
                    ₹{" "}
                  {service.totalCost
                  ? (
                    parseFloat(service.totalCost) -
                    (parseFloat(service.totalCost) * parseFloat(service.discountPercent || 0)) / 100
                    )
                  : "0.00"}
                </li>
                <li>
                    <b>Note from service manager :</b> {" "}
                    {service.estimationNotes}
                </li>
            </ul>
        </div>
        </div>

        <div className='flex flex-row justify-end items-center text-sm xl:text-base font-semibold w-auto'>
            {(service.reason && service.status==="rejected") ? (
                <div className='border-2 rounded-md border-red-600 p-3 text-red-600 text-sm xl:text-base font-medium shadow-lg'>                  
                    <p className='text-sm xl:text-base font-medium pb-2 text-blue-500'>Your rejection reason : {capitalizeFirstLetter(service.clientApprovalReason)}</p>
                    <p className='text-sm xl:text-base font-medium pb-2'>The modified estimation request you sent has been rejected by the other side.</p>
                    <p className='text-sm xl:text-base font-medium'>Rejection reason provided by the other side : {capitalizeFirstLetter(service.reason)}</p>
                    
                </div>
            ) : service.clientApprovalStatus==="rejected" ? (
                <div className='border-2 rounded-md border-red-600 p-3 text-red-600 shadow-lg'>
                  <p className='text-sm xl:text-base font-medium pb-2'>You rejected the estimation request.</p>
                  <p className='text-sm xl:text-base font-medium pb-2'>Waiting for the other side to review and respond.</p>
                  <p className='text-sm xl:text-base font-medium text-red-500'>Your rejection reason : {capitalizeFirstLetter(service.clientApprovalReason)}</p>
                  <div className='flex flex-row space-x-4 mt-5'>
                    <button 
                    onClick={handleAcceptRequest}
                    className='bg-green-100 text-green-700 border rounded-md border-green-700 px-3 py-2'>
                        Accept
                    </button>
                    <button 
                        onClick={handleRejectRequest}
                        className='bg-red-100 text-red-700 border rounded-md border-red-700 px-3 py-2'>
                            Reject
                    </button>
                  </div>  
                </div>
            ) : service.clientApprovalStatus==="approved" ? (
                <div className='border-2 rounded-md border-blue-700 p-3 text-blue-500 shadow-lg'>
                    <p className='text-sm xl:text-base font-medium pb-2'>You accept the estimation request.</p>
                    {/* <p className='text-sm xl:text-base font-medium pb-2'>Waiting for the other side to review and respond.</p> */}
                    <p className='text-sm xl:text-base font-medium text-green-500'>Your reason for accept : {capitalizeFirstLetter(service.clientApprovalReason)}</p>
                    
                </div>
            ) : (
                <div className='flex flex-row space-x-4'>
                    <button 
                    onClick={handleAcceptRequest}
                    className='bg-green-100 text-green-700 border rounded-md border-green-700 px-3 py-2'>
                        Accept
                    </button>
                    <button 
                        onClick={handleRejectRequest}
                        className='bg-red-100 text-red-700 border rounded-md border-red-700 px-3 py-2'>
                            Reject
                    </button>
                </div>
            )}
          {/* <div className='flex flex-row space-x-4'>
                    <button 
                    onClick={handleAcceptRequest}
                    className='bg-green-100 text-green-700 border rounded-md border-green-700 px-3 py-2'>
                        Accept
                    </button>
                    <button 
                        onClick={handleRejectRequest}
                        className='bg-red-100 text-red-700 border rounded-md border-red-700 px-3 py-2'>
                            Reject
                    </button>
          </div> */}
           
        </div>

        <ReasonModal
          isOpen={modalOpen}
          onClose={() => setModalOpen(false)}
          onSubmit={handleModalSubmit}
          type={modalType}
        />
    </div>
  )
}
